import AppCard from '@crema/core/AppCard';
import * as Icons from '@mui/icons-material'
import { alpha, Typography } from '@mui/material';
import { Stack } from '@mui/system';
import PropTypes from 'prop-types'

export const CardCounter = ({ title, description, value, icon, color, active, colorActive, onClick, isMonitoring, children }) => {
    const IconComponent = Icons[icon]

    return (
        <AppCard
            sxStyle={{
                flex: 1,
                minHeight: 100,
                cursor: !onClick || isMonitoring ? 'default' : 'pointer',
                width: '100%',
                backgroundColor: `${active ? colorActive : '#fff'} !important`,
            }}
            onClick={() => !isMonitoring && onClick()}
        >
            <Stack spacing={4}>
                <Stack direction={{ xs: 'column', md: 'row' }} spacing={4} alignItems={{ xs: 'start', md: 'center' }}>
                    <Stack>
                        <Stack width={70} height={70} bgcolor={active ? '#fff' : alpha(color, 0.3)} borderRadius={'100%'} alignItems={'center'} justifyContent={'center'}>
                            {(icon || icon !== '') && <IconComponent sx={{ color: active ? colorActive : color, fontSize: 40 }} />}
                        </Stack>
                    </Stack>

                    <Stack direction={'row'} flex={1} width={'100%'} spacing={4} alignItems={'center'}>
                        <Stack flex={1} spacing={1}>
                            <Typography fontWeight={'bold'} variant='h2' sx={{ color: active ? '#fff' : 'text.primary' }}>{title}</Typography>
                            <Typography variant='body1' sx={{ color: active ? '#fff' : 'text.primary' }}>{description}</Typography>
                        </Stack>

                        <Stack alignItems={'center'}>
                            <Typography fontWeight={'bold'} fontSize={45} sx={{ color: active ? '#fff' : 'text.primary' }}>{value}</Typography>
                            <Typography mt={-4} sx={{ color: active ? '#fff' : 'text.primary' }}>Dokumen</Typography>
                        </Stack>
                    </Stack>
                </Stack>
                {children && <Stack>{children}</Stack>}
            </Stack>
        </AppCard>
    )
}

CardCounter.propTypes = {
    title: PropTypes.string,
    description: PropTypes.string,
    value: PropTypes.number,
    icon: PropTypes.any,
    color: PropTypes.any,
    active: PropTypes.bool,
    colorActive:PropTypes.any,
    onClick: PropTypes.func,
    isMonitoring: PropTypes.bool,
    children: PropTypes.node
}
